import { render } from "./EmotivFooter.vue?vue&type=template&id=5d0497b5&scoped=true"
import script from "./EmotivFooter.vue?vue&type=script&lang=js"
export * from "./EmotivFooter.vue?vue&type=script&lang=js"

import "./EmotivFooter.vue?vue&type=style&index=0&id=5d0497b5&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0497b5"]])

export default __exports__